<template>
    <div class="overflow-auto">
      <!-- {{tasks}} -->
        <table v-bind:class="[isDeliveryCalender? '' : 'table-hover']"   class="table" id="dataTable" width="100%" cellspacing="0">
            <thead>
               <tr>
    <th v-for="(header, index) in weekendDays" :key="index">
      {{ header }}
      <span v-if="header === 'Due Date'" @click="sort('due_date')" style="cursor: pointer">
        <svg width="9" height="11" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <!-- Your SVG paths here -->
        </svg>
      </span>
    </th>
  </tr>
</thead>
        
<tbody v-if="filteredTasksProp" >
  <tr v-if="isLoader" id="table_row">
          <td colspan="16">
            <b-skeleton-wrapper>
              <b-skeleton height="40px"></b-skeleton>
              <b-skeleton height="40px"></b-skeleton>
              <b-skeleton height="40px"></b-skeleton>
            </b-skeleton-wrapper>
          </td>
        </tr>
        <tr v-else-if="filteredTasksProp.length > 0">
          <td  v-for="(header, index) in weekendDays" :key="index" class="borderTd" rowspan="4">
            <template v-if="groupedTasks[header]">

              <div class="new-border" v-for="(task, taskIndex) in groupedTasks[header]" :key="taskIndex" :class="{ 'delivered-task': task.isDelivered }">
                <a @click="quickView" :data-id="task.id" href="javascript:void(0);">
                        {{ truncateTitle(task.title) }}
                </a>
              </div>
            </template>

          </td>
        </tr>
          <tr v-else-if="filteredTasksProp.length < 1">
              <td colspan="7" class="text-center"> No Record Found
              </td>
          </tr>

      </tbody>
  <tbody id="table_body" v-else>
              <tr  v-if="isLoader"  id="table_row"  >
                <td colspan="16">
                  <b-skeleton-wrapper >
                      <b-skeleton height="40px" ></b-skeleton>
                      <b-skeleton height="40px"></b-skeleton>
                      <b-skeleton height="40px"></b-skeleton>
                  </b-skeleton-wrapper>
                </td>
              </tr>
              <tr  v-show="!isLoader" v-for="task in tasks" :key="task.id">
                <td class="text-nowrap">
                  {{ task.task_number }}
                </td>
                
                <td v-if="task.organizations">
                  {{ task.organizations}}
                </td>
                <td v-else class="text-center">
                   -----
                </td>
                <td >
                  {{ task.title}}
                </td>
                <td>
                  {{ task.created_at}}
                </td>
                <td  v-if="[userRoles.developer].includes(role_id) && task.dev_due_date!=''">
                  {{ task.dev_due_date }}
                </td>
                <td  v-else-if="[userRoles.adh,userRoles.adh_helper].includes(role_id) && task.adh_due_date != ''">
            {{ task.adh_due_date }}
          </td>
          <td v-else-if="[userRoles.development_lead].includes(role_id)" class="text-center">
            {{ task.dev_due_date }}
          </td>
           <td v-else class="text-center">
            {{ task.task_due_date_time }}
          </td>

          <td v-if="task.priority != ''">
            {{ prioritiesList.find(opt => opt.value == task.priority).name }}
          </td>
          <td v-else class="text-center">
            -----
          </td>
          <td v-if="task.assigned_to.hasOwnProperty('name')">
            {{ task.assigned_to.name }}
          </td>
        
          <td v-if="task.qa_to != ''">
             {{ task.qa_to.name }}
          </td>
           
         <td>
            <span v-if="task.qa_issue.task_issue != '' ">{{ task.fixed_qa_issues_count +'/' +  task.total_qa_issues_count}}</span>
         </td>

          <td>
            {{ getStatusName(task.status) }}
          </td>
          
          <td class="text-center">
            <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
              <span class="fas fa-ellipsis-v"></span>
            </a>
            <ul class="dropdown-menu action-list">
          
              <!-- <li><router-link :to="'/development-tasks/schedular'" class="dropdown-item"> View</router-link></li> -->
              <li><a class="dropdown-item" v-if=" $can('view_task')" :data-id="task.id" @click="quickView"> View</a></li>
              <li><a class="dropdown-item" v-if=" $can('edit_task')" :data-id="task.id"
                  @click="edit"> Edit</a></li>
              <li><a class="dropdown-item"
                  v-if="(task.team_id !== ''|| task.status !== 1 ) &&  $can('view_task_assign_to')"
                  @click="assignTo(task)">Assign To</a></li>
              <li><a class="dropdown-item"
                  v-if="task.assigned_to.id && task.status != 0 && task.status != 5 && $can('view_task_start_work')"
                  :data-id="task.id" @click="startWorking">Start Working</a></li>

              <!-- Status changes grouped under hover submenu (like "Set Priority") -->
              <li class="dropdown-submenu" v-if="canShowSetStatus(task)">
                <a class="dropdown-item dropdown-toggle set-status-item" href="javascript:void(0);">Set Status</a>
                <ul class="dropdown-menu">
                  <li><a class="dropdown-item"
                      v-if="$can('view_task_on_hold')"
                      @click="onHoldTask(task.id, 10,3,'view_task_on_hold')">On Hold</a></li>
                  <li><a class="dropdown-item" v-if="task.status != 4 && $can('view_task_completed')"
                      @click="updateStatus(task.id, 4,'','view_task_completed')">Completed</a></li>
                  <li><a class="dropdown-item" v-if="task.status == 3 && $can('view_task_resume')"
                      @click="updateStatus(task.id, 2, 'resume','view_task_resume')">Resume</a></li>
                  <li><a class="dropdown-item"
                      v-if="task.status != 5 && $can('view_task_in_review')"
                      @click="updateStatus(task.id, 5,'','view_task_in_review')">In Review</a></li>
                  <li><a class="dropdown-item" v-if="task.status != 10 && $can('view_task_in_qa')"
                      @click="updateStatus(task.id, 10,'','view_task_in_qa')">Ready for QA</a></li>
                  <li><a class="dropdown-item" v-if="task.status != 6 && $can('view_task_in_qa')"
                      @click="updateStatus(task.id, 6,'','view_task_in_qa')">In QA</a></li>
                  <li><a class="dropdown-item" v-if="task.status != 11 && $can('view_task_in_qa')"
                      @click="updateStatus(task.id, 11,'','view_task_in_qa')">Bug Fixing</a></li>
                  <li><a class="dropdown-item" v-if="task.status != 14 && $can('view_task_in_qa')"
                      @click="updateStatus(task.id, 14,'','view_task_in_qa')">Bug Fixed</a></li>
                  <li><a class="dropdown-item" v-if="task.status != 13 && $can('view_task_in_qa')"
                      @click="updateStatus(task.id, 13,'','view_task_in_qa')">Discussion Pending</a></li>
                  <li><a class="dropdown-item" v-if="task.status != 12 && $can('view_task_in_qa')"
                      @click="updateStatus(task.id, 12,'','view_task_in_qa')">QA Passed</a></li>
                  <li><a class="dropdown-item"
                       v-if="task.status != 7 && $can('view_task_pr_review')"
                      @click="updateStatus(task.id, 7,'','view_task_pr_review')">PR Review</a></li>
                  <li><a class="dropdown-item"
                       v-if="(task.status == 6 || task.status == 7 || task.status == 12) && ($can('view_task_in_qa') || $can('view_task_pr_review'))"
                      @click="markReadyToDeploy(task)">Ready To Deploy</a></li>
                </ul>
              </li>

               <li><a v-if="$can('task_progress')" class="dropdown-item" @click="UpdateProgress(task.id, 9,'task_progress')">Update Progress</a></li>
                <li><a v-if="$can('add_issue') || ([userRoles.adh].includes(role_id) && user_id == 76)"   class="dropdown-item" @click="AddIssue(task.id,task, 11,'add_issue')">Add Issues</a></li>
              <li><a class="dropdown-item"
                  v-if="task.status != 4 && $can('view_task_extnd_due_date')" 
                  @click="extendDueDate(task, activityTypes.extendDueDate,'view_task_extnd_due_date')"> {{ extendText(task,'due_date') }} Due-Date</a></li>
              <li><a class="dropdown-item"
                  v-if="task.status != 4 && $can('view_task_extnd_dev_due_date')"
                  @click="extendDueDate(task, activityTypes.extendDeveloperDueDate,'view_task_extnd_dev_due_date')"> {{ extendText(task,'dev_due_date') }}  Developer Due-Date</a></li>
              <li><a class="dropdown-item"
                  v-if="task.status != 4 && $can('view_task_extnd_adh_due_date')"
                  @click="extendDueDate(task, activityTypes.extendADHDueDate,'view_task_extnd_adh_due_date')"> {{ extendText(task,'adh_due_date') }} ADH Due-Date</a></li>
              <li><a class="dropdown-item" v-if="$can('view_task_is_notified') && task.is_customer_notified !== 1" @click="isNotified(task.id)">Is Notified</a></li>
              <li><a class="dropdown-item text-danger my-1"  v-if=" $can('delete_task')" @click="deleteTask(task.id)" > Delete</a> </li>

            </ul>
          </td>
          <!-- <td>
                </td> -->
              </tr>
              <tr  v-if="tasks.length < 1 && !isLoader" >
                <td colspan="11" class="text-center"> No Record Found
                  </td>
              </tr>
            </tbody>
        </table>
        <div v-if="!isLoader && !filteredTasksProp">
          <paginate  v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''"
          :first-button-text="''" :last-button-text="''" :first-last-button="true"
          :container-class="'pagination pagination-sm float-right mb-2 mr-4 mb-0'" :page-class="'page-item'"
          :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'"
          :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
            <span class=" float-right mb-2 mr-4 mb-0 display-rows" style="color:#48a6a6;">Display Rows:
              <b>{{totalRows}}</b>
              </span>
            <span class=" float-right mb-2 mr-4 mb-0 display-rows" style="color:#48a6a6;">Total Tasks:
              <b>{{totalRecords}}</b>
              </span>
        </div>


         <!-- <h5 style="text-align: center; margin-top:2rem;" v-if="tasks.length < 1 && !isLoader">
          No data found.
        </h5> -->
    </div>
</template>
<script>

import taskForm from "./form.vue";
import quickView from "./quickView.vue";
import moment from "moment";
  // Vue.filter("formatDate", function (value) {
  //   if ( value != null) {
  //     return moment(String(value)).format("DD MMM, Y");
  //   }
  // });
export default {
  components: {
    taskForm,
    quickView,
    },
  props:['orgList','tasks','setSkeletonLoader','totalRows','totalPages','developers','selTab','teams','weekendDaysProp',"filteredTasksProp"],
  data: function () {
      return {
        isLoader: false,
        isDeliveryCalender: false,
      
        //  currentDate: new Date(),
        // search: '',
        // statusNames: {
        //   0: 'Pending',
        //   1: 'Assigned',
        //   2: 'In Progress',
        //   3: 'On Hold',
        //   4: 'Delivered',
        // },
                detail: {
            checked: false
        },
        count: 0,
        task: {},
        sortingBy: {
          created_at: true,
          due_date: true,
          assigned_to: true,
        },
        role_id: '',
        user_id: '',
        weekendDays:[],
        filteredTasksProp:[],
        maxLength: 0
      };
    },
    computed:{
          
  groupedTasks() {
  const grouped = {};
  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  let maxLength = 0;

  this.filteredTasksProp.forEach(task => {
    const dayOfWeek = this.getDayOfWeek(task.due_date);
    grouped[dayOfWeek] = grouped[dayOfWeek] || [];
    grouped[dayOfWeek].push(task);
    maxLength = Math.max(maxLength, grouped[dayOfWeek].length);
  });

  daysOfWeek.forEach(day => {
    grouped[day] = grouped[day] || [];
    const diff = maxLength - grouped[day].length;
    grouped[day].push(...Array(diff).fill([]));
  });
  return grouped;
},
       currentPage:{
        get: function () {
          this.selectedPage = this.$store.getters["tasks/currentPage"];
          return this.selectedPage;
        },
        set: function () { },
      },
       adminUsers:function(){
        return this.$store.getters['users/adminUsers'];
            },
      statusNames:function(){
        return this.$store.getters['tasks/statusNames'];
      },
      prioritiesList: function () {
          return this.$store.getters['tasks/prioritiesList'];
      },
      search:function(){
        return this.$store.getters['tasks/search'];
      },
      showskLoader: {
        get:function(){
          return this.setSkeletonLoader
        },
        set: function (val) {
          this.isLoader = val;
          return val;
         },
      },
      totalRecords: function () {
        return this.$store.getters["tasks/totalRecords"];
      },
      userRoles: function () {
        return this.$store.getters['persist/userRoles'];
      },
      activityTypes: function () {
        return this.$store.getters['tasks/activityTypes'];
      },

    },
    watch:{
      showskLoader: function (val) {
        this.isLoader = val;
        return val;
      },
      filteredTasksProp: {
      handler(newValue) {
        console.log('task',newValue);
        this.filteredTasksProp = newValue;
      },
      immediate: true, 
    },
     } ,
    mounted: function () {
      this.user_id = parseInt(localStorage.getItem('admin_id')); 
      this.showskLoader = this.setSkeletonLoader;
      this.role_id = parseInt(localStorage.getItem('role'));
      if(this.weekendDaysProp){
        this.weekendDays = this.weekendDaysProp;
        this.isDeliveryCalender = true;
      }else{
        this.weekendDays = [
          "Task #",
          "Customer Name",
          "Task Title",
          "Open Date",
          "Due Date",
          "Priority",
          "Assigned To",
          "Assign Qa",
          "Issue",
          "Status",
          "Actions"
        ];
    
      }
    },
    methods:{
      extendText(item,date_type) {
      return item[date_type] ? 'Extend' : 'Set';
      },
      truncateTitle(title) {
        if (title && title.length > 30) {
          return title.slice(0, 30) + '.....';
        } else if (title) {
          return title;
        } else {
          return '';
        }
      },
       getDayOfWeek(dateString) {

        const daysOfWeek = [ "Sunday","Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const date = new Date(dateString);
        const dayOfWeek = date.getDay();
        return daysOfWeek[dayOfWeek];
      },
        setPage(page) {
          this.$emit("setPage", page);
        },
        edit(event){
          this.$store.dispatch("tasks/edit",[event.target.dataset.id]).then((response)=>{
            this.$store.dispatch("modal/taskModal", {
              action: "edit",
              title: "Edit Task",
              formData: {
                task: response,
                developers: this.developers,
              },
               component: taskForm 
             });
          });
        },
        assignTo(task){
         
          this.$store.dispatch("modal/taskModal", {
            action: "assign_to",
            title: "Update Status",
            formData: {
              task: task,
              developers: this.developers,
            },
            component: taskForm,
          });    
        },
   isNotified(id, status_name='') {
    
  //  const task = this.tasks.find(task => task.id === id);
  //   if (task && task.is_customer_notified === 1) {
  //       this.$toast.info("Task has already been notified.");
  //       return;
  //   }

    this.$store.dispatch("tasks/updateNotificationStatus", [id])
      .then(() => {
        this.$parent.getRecords();
        let msg = '';
        if (status_name == 'isnotified') {
          msg = "has been notified";
        } else {
          msg = "status has been notified to " + this.getStatusName(status);
        }
        this.$toast.success("Task " + msg + " successfully.");
      });
},

        extendDueDate(task,activity_type,prms){
          let title = '';
          if(activity_type == this.activityTypes.extendDueDate){
            title = this.extendText(task,'due_date')+" Due-Date";
          }else if(activity_type == this.activityTypes.extendDeveloperDueDate){
            title = this.extendText(task,'due_date')+" Developer Due-Date";
          }else if(activity_type == this.activityTypes.extendADHDueDate){
            title = this.extendText(task,'due_date')+" ADH Due-Date";
          }
          
          // let task_info = event.target.dataset;
          this.$store.dispatch("modal/taskModal", {
            action: "extend_due_date",
            title: title,
            formData: {
              task: task,
              type: activity_type,
              prms:prms,
            },
            component: taskForm,
          });         
        },
     async  UpdateProgress(id,activity_type,permission){
          let progress = '';
          if(activity_type == this.activityTypes.developerReport){
            progress = "";
         
          }
    let prevReports =  await this.$store.dispatch("tasks/prevReport", {
            task_id: id,
            prms: permission
          });

          // let task_info = event.target.dataset;
          this.$store.dispatch("modal/taskModal", {
            action: "developer_report",
            title: progress,
            formData: {
              task_id: id,
              type: activity_type,
              prevReports:prevReports,
              permission:permission
            },
            component: taskForm,
          });         
        },

        async  AddIssue(id, task, activity_type, permission){
          // Always load the full task before opening the modal.
          // The list endpoint updates issue counts, but often does not include the full `qa_issue` array.
          let fullTask = task;
          try {
            const response = await this.$store.dispatch("tasks/view", [id]);
            // `tasks/view` returns a wrapper (`res.post`) with the actual task at `response.task`.
            if (response && response.task) {
              fullTask = response.task;
            }
          } catch (e) {
            // Fallback to whatever we already have in the row.
            // eslint-disable-next-line no-console
            console.error(e);
          }

          this.$store.dispatch("modal/taskModal", {
            action: "add_qa",
            title: 'Add Issues',
            width: true,
            formData: {
              task_id: id,
              task: fullTask,
              type: activity_type,
              permission: permission
            },
            component: taskForm,
          });         
        },
        async  onHoldTask(id,activity_type,status,permission){
          let progress = '';
          if(activity_type == this.activityTypes.onHoldTask){
            progress = "On Hold";
         
          }

          // let task_info = event.target.dataset;
          this.$store.dispatch("modal/taskModal", {
            action: "onholdtask",
            title: progress,
            formData: {
              task_id: id,
              type: activity_type,
              status:status,
              permission:permission
            },
            component: taskForm,
          });         
        },
        startWorking(event){
          let task_info = event.target.dataset;
          this.$store.dispatch("message/update", {
            title: "Update Status",
            body: "All the active tasks will be de-activated",
            class: "warning",
            confirm: true,
          });

      this.$bus.$off("proceed");
      this.$bus.$once("proceed", () => {
        this.$store.dispatch("message/close");
        this.updateStatus(task_info.id, 2,'','view_task_start_work');

      });
    },
    updateStatus(id, status, status_name = '',prms) {
      let formData = {};
      formData.id = id;
      formData.status = status;
       formData.prms = prms;
      this.$store.dispatch("tasks/updateStatus", [formData])
        .then((response) => {
          this.$parent.getRecords();
          let msg = '';
          if (status_name == 'resume') {
            msg = "has been resumed";
          } else {
            msg = "status has been updated to " + this.getStatusName(status);
          }
          this.$toast.success("Task " + msg + " successfully.");
          this.$store.dispatch('tasks/setUnnotifiedTaskCount');
        });
    },
    markReadyToDeploy(task) {
      if (!task || !task.id) return;
      // Use an existing permission the user already has so `tasks/updateStatus` is allowed to run.
      // Prefer PR Review permission if available; otherwise fall back to In QA permission.
      const prms = this.$can('view_task_pr_review') ? 'view_task_pr_review' : 'view_task_in_qa';
      this.updateStatus(task.id, 9, '', prms);
    },
    quickView(event) {
      this.$store.dispatch("tasks/view", [event.target.dataset.id]).then((response) => {
        this.$store.dispatch("modal/taskQuickView", {
          title: "Task Details",
          formData: {
            task: response,
            developers: this.developers,
          },
          component: quickView,
        });
      });

    },
    getStatusName(status) {
      return this.statusNames[status] || 'Pending';
    },
    
    deleteTask(id) {
              if (confirm("Are you sure you want to delete this task?")) {
              this.$store.dispatch("tasks/delete",[id]).then((response)=>{
              this.tasks = this.tasks.filter(task => task.id !== id);
          });
           }
         },sort(column) {
      let direction = this.sortingBy[column];
      localStorage.setItem('direction', direction);
      localStorage.setItem('column', column);

      if (localStorage.getItem('setPageDirection') == 'false' && direction == true) {
        localStorage.setItem('direction', false);
        direction = false;
        this.sortingBy[column] = false;
      }

          this.$emit('update-sortingby-variable', {column: column, direction: direction == true  ? "asc" : "desc"});
          this.$parent.getRecords();
          this.sortingBy[column] = !this.sortingBy[column];
          localStorage.setItem('setPageDirection', this.sortingBy[column]);
        },
        getRecords() {
          this.$parent.getRecords();
        }
        ,
        canShowSetStatus(task) {
          // Show "Set Status" if user can change status in any way.
          // Individual options still apply their own v-if checks.
          return (
            this.$can('view_task_on_hold') ||
            this.$can('view_task_completed') ||
            this.$can('view_task_resume') ||
            this.$can('view_task_in_review') ||
            this.$can('view_task_in_qa') ||
            this.$can('view_task_pr_review')
          );
        }
      },
      
}
</script>
<style scoped>

table thead th tr th{
  text-align: left !important;
}
.borderTd{
  padding: 0 !important;
  vertical-align: top !important;
  max-width: 115px;

}
.borderTd div{
  border-bottom: 1px solid #dee2e6;
    min-height: 60px;

padding: 8px;
}
.borderTd a{
 color: #323a47;
}
.delivered-task a {
  color: green;
  font-weight: 600;
}

.table tbody tr td div:hover{
  background-color: rgba(232, 246, 246, 0.6);
}

/* Hover submenu for "Set Status" */
.dropdown-submenu {
  position: relative;
}
.dropdown-submenu > .dropdown-menu {
  top: 0;
  /* Actions menu is on the far-right; open submenu to the LEFT so it stays visible */
  left: auto;
  right: 100%;
  margin-top: -6px;
  margin-right: 2px;
  display: none;
  z-index: 2000;
}
.dropdown-submenu:hover > .dropdown-menu {
  display: block !important;
}
.dropdown-submenu > .set-status-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dropdown-submenu:hover > .set-status-item,
.dropdown-submenu:focus-within > .set-status-item {
  /* Match default dropdown-item hover (same as "On Hold") */
    color: #16181b;
    text-decoration: none;
    background-color: #e9ecef;
    border-radius: 1px;
}
.dropdown-submenu > .set-status-item::after {
  content: "›";
  font-size: 18px;
  line-height: 1;
  margin-left: 10px;
  opacity: 0.8;
}
.dropdown-submenu:hover > .set-status-item::after,
.dropdown-submenu:focus-within > .set-status-item::after {
  opacity: 1;
}
</style>
